module.exports = __parcel__import__.meta.resolve("63u30");